import Vue from 'vue'
import App from './App.vue'
import router from './modules/router'
import store from './modules/store'
//import meta from './modules/meta'
import './modules/registerServiceWorker'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  //meta,
  render: h => h(App)
}).$mount('#app')
